<template>
  <div>
    <vs-card>
      <vs-row class="mt-4">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <expense-detail :expense_id="expense_id" @refresh-table="getExpenses"/>
          <expense-filter v-model="filters" @input="searchExpense" />
          <new-expense :data="sidebarData" @success="searchExpense"/>
          <assign-client :expense="expense" />
          <div id="expense-table-loading" class="vs-con-loading__container">
            <vs-table :data="expenseList" minHeight="60vh">
              <template slot="header">
                
                <vs-button
                  color="primary"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-file-plus"
                  class="mx-2"
                  @click="openNewExpense"
                  v-show="hasPermission(['IU ACCOUNTING EDIT'])"
                >{{$t('new_expense')|capitalize}}</vs-button>
                <div>
                <export-button :data="params" :url="'expenses/export/kj4asg_dasd_adjy5gasd5as654_5t4d'"  :disabled="!allowedExport" :limit_export="total_registers"/> <!-- :disabled="expenseList.length==0"  -->
                </div>
                <div class="con-input-search vs-table--search">
                  <input
                    class="input-search vs-table--search-input"
                    type="text"
                    v-model="params.search"
                    @keypress.enter="searchExpense"
                  />
                  <vs-icon icon="search"></vs-icon>
                </div>
                <vs-button
                  color="primary"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-filter"
                  class="mx-2"
                  radius
                  @click="openFilter"
                ></vs-button>
                
              </template>
              <template slot="thead">
                <th-sort width="20vw" :text="$t('company')"   column="com.CompanyName" @sort="handleClickSort"/>
                <th-sort width="20vw" :text="$t('client')"    column="cl.ClientName" @sort="handleClickSort"/>
                <th-sort width="20vw" :text="$t('vendor')"    column="v.VendorName" @sort="handleClickSort"/>
                <th-sort width="20vw" :text="`${$t('folio')}|${$t('date')}|${$t('recepcion')}|${$t('pay_date')}`" column="p.Year,p.Week" @sort="handleClickSort"/>
                <th-sort width="20vw" :text="$t('category')"  column="cat.CategoryName" @sort="handleClickSort"/>
                <th-sort width="20vw" :text="$t('total')"     column="Expenses.Total" @sort="handleClickSort"/>
                <th-sort width="20vw" :text="$t('status')"    column="st.StatusName" @sort="handleClickSort"/>
                <vs-th class="" width="20vw"> </vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                   <vs-td class="text-left w-2/12">
                    {{ data[indextr].CompanyName }}
                  </vs-td>
                  <vs-td class="text-left w-2/12">
                    {{ data[indextr].ClientName }}
                  </vs-td>
                  <vs-td class="text-left w-2/12">
                    {{ data[indextr].VendorName }}
                  </vs-td>
                  <vs-td class="text-left w-2/12" v-if="data[indextr].StatusId != 1">
                    {{ `${data[indextr].Folio} | ${formatDate(data[indextr].ExpenseDate)} |  ${formatDate(data[indextr].ReceivedDate,'MMM-DD')} | ${formatDate(data[indextr].PayDate)}` }}
                  </vs-td>
                  <vs-td class="text-left w-2/12" v-else>
                    {{ `${data[indextr].Folio} | ${formatDate(data[indextr].ExpenseDate)}| ${formatDate(data[indextr].ReceivedDate,'MMM-DD')}`}}
                  </vs-td>
                  <vs-td class="text-left w-1/12">
                    <span
                        class="material-icons sm"
                        :style="{
                          fontSize: '8px',
                          color: data[indextr].category_color,
                        }"
                      >
                        lens
                      </span>
                    {{ data[indextr].CategoryName }}
                  </vs-td>
                  <vs-td class="text-left w-1/12">
                    $ 
                    {{
                      `${formatNumber(parseFloat(data[indextr].totalxml).toFixed(4), 2)} ${data[indextr].CurrencyId}`
                    }}
                  </vs-td>
                  <vs-td class="text-left w-1/12">
                    <vs-button
                      :color="data[indextr].color || 'grey'"
                      text-color="white"
                      type="filled"
                      size="small"
                      disabled
                    >
                      {{ data[indextr].StatusName }}
                    </vs-button>
                  </vs-td>
                  <!-- style="width: 10vw !important;" -->
                  <vs-td class="w-1/12 px-0 text-left"  >
                    <vs-row class="text-left">
                      <vs-col class="w-1/3 mx-0 px-0">
                        <action-icon
                          class="mx-1"
                          icon="ArrowRightCircleIcon"
                          :tooltip="$t('details')"
                          @click="expenseDetail(data[indextr].ExpenseId)"
                        />
                      </vs-col>
                      <vs-col class="w-1/3 mx-0 px-0">
                      <action-icon
                          class="mx-1"
                          icon="LinkIcon"
                          :tooltip="$t('assign')"
                          @click="assign(data[indextr])"
                          v-if="(data[indextr].StatusId === '1' || data[indextr].StatusId === '2') && hasPermission(['IU ACCOUNTING EDIT'])"
                        />
                      </vs-col>
                      <vs-col class="w-1/3 mx-0 px-0">
                      <feather-icon
                          v-if="data[indextr].cfdi==0 && hasPermission(['IU ACCOUNTING EDIT'])"
                          icon="EditIcon"
                          class="mx-1"
                          svgClasses="w-5 h-5 hover:text-primary stroke-current"
                          @click.stop="editData(data[indextr].ExpenseId)"
                        />
                      </vs-col>
                    </vs-row>
                        
                        
                        
                        
                    
                    
                  </vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td colspan="100%">
                    <div
                      v-if="data.length"
                      v-observe-visibility="infiniteHandler"
                    ></div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vs-col>
      </vs-row>
    </vs-card>
  </div>
</template>

<script>
import moduleExpense from '@/store/expense/moduleExpense.js'
import ExpenseDetail from '@/views/apps/accounting/components/ExpenseDetail.vue'
import ExpenseFilter from '@/views/apps/expense/ExpenseFilter.vue'
import NewExpense from    '@/views/apps/expense/newExpense.vue'
import ActionIcon from '@/views/qb-components/actions/ActionIcon.vue'
import ThSort from '@/views/components/ThSort.vue'
import AssignClient from './AssignClient.vue'
import client from '@/http/requests/client'
import expense from '@/http/requests/expense'
import loading from '@/mixins/Loading.js'
import ExportButton from '@/views/components/ExportButton.vue'
export default {
  created () {
    if (!moduleExpense.isRegistered) {
      this.$store.registerModule('expense', moduleExpense)
      moduleExpense.isRegistered = true
    }
  },
  components: {
    ActionIcon,
    AssignClient,
    ExpenseDetail,
    ExpenseFilter,
    ExportButton,
    NewExpense,
    ThSort
  },
  computed: {
    expenseList () {
      return this.$store.state.expense.expenseList
    },
    currentFilter() {
      return this.$store.state.filterExpenses
    }
  },
  data: () => ({
    allowedExport:false,
    expense_id: '',
    expense:{},
    sidebarData:{},
    clientList:[],
    lastPage: 1,
    limitLength:25000,
    total_registers:1,
    params:{
      page:1,
      search:'',
      sort:['DESC'],
      sortBy:['Expenses.created_at']
    },
    filters: {
      status: [],
      company: [],
      client: [],
      vendor: [],
      start_date: '',
      end_date: ''
    }
  }),
  methods: {
    infiniteHandler (isVisible) {
      if (!isVisible) {
        return
      }
      if (this.page >= this.lastPage || this.lastPage=='1') {
        return
      }
      this.params.page++
      this.getExpenses()
    },
    openFilter () {
      this.$store.dispatch('toggleSidebar', 'accounting-search-filter')
    },
    expenseDetail (expense_id) {
      this.$store.dispatch('setFilter', {})
      this.expense_id = expense_id
      this.$store.dispatch('toggleSidebar', 'expense-detail')
    },
    searchExpense () {
      this.params.page = 1
      this.getExpenses()
    },
    getExpenses () {
      if(this.currentFilter != null){
        this.filters.status=[Number(this.currentFilter)]
      }
      let data = Object.assign(this.params, this.filters)
      data.vendor = data.vendor.map((el) => el.id)
      this.openLoading('expense-table-loading')
      this.$store
        .dispatch('expense/fetchExpenseList', data)
        .then((res) => {
          this.lastPage = res.data.last_page
          this.closeLoading('expense-table-loading')
          //ALLOWED EXPORT
          this.total_registers=Number(res.data.total)
            this.allowedExport=false
            if(Number(res.data.total) <= this.limitLength && res.data.total!=0){
              this.allowedExport=true
            }
        })
        .catch((err) => {
          this.closeLoading('expense-table-loading')
        })
    },
    getClients () {
      client
        .list()
        .then((res) => {
          this.clientList = res.data.clients
        })
        .catch((err) => {
        })
    },
    assign (expense) {
      this.expense = expense
      this.$store.dispatch('toggleSidebar', 'assign-client')
    },
    handleClickSort (e) {
      this.params.sort = e.sort
      this.params.sortBy = e.sortBy
      this.searchExpense()
    },
    openNewExpense () {
      this.sidebarData={}
      this.$store.dispatch('toggleSidebar', 'accounting-new-expense')
    },
    editData(expense_id){
      this.openLoading('expense-table-loading')
      expense.dataToFillExpenseEdit({ExpenseId:expense_id}).then(res => {
        this.sidebarData = res.data.data
        this.$store.dispatch('toggleSidebar', 'accounting-new-expense')
        this.closeLoading('expense-table-loading')
      }).catch(err => {
        console.log(err)
        this.closeLoading('expense-table-loading')
      })
      //expense.dataExpenseExpenseItemsEdit({ExpenseId:expense_id})
    }
  },
  mixins: [ loading],
  mounted () {
    this.$store.dispatch('expense/clearExpenseList')
    this.searchExpense()
    this.getClients()
  },
  props: {
    data: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style>
.qb-sticky {
  background: white;
  position: sticky;
  top: 0;
}
</style>
